<template>
  <div>
    <h1>{{ $t('h1') }}</h1>
    <div v-html="$t('text')" class="mb-3" />
    <div style="max-width: 350px">
      <VTextField
        dense
        outlined
        readonly
        :value="createPartnerLink()"
      />
    </div>
    <div>
      {{ $t('rules') }}
    </div>
  </div>
</template>

<script>
import useCompany from '@/compositions/useCompany';

export default {
  name: 'Partnership',
  setup() {
    const { company } = useCompany();

    function createPartnerLink() {
      return `${process.env.VUE_APP_FRONT_URL}/?partner=${company.value.id}`;
    }

    return {
      createPartnerLink,
    };
  },
};
</script>

<style lang="scss" scoped>
  .h1 {
      font-size: 1.5rem;
      line-height: 1.25;
      font-weight: 400;
      color: #212121;
      padding-top: 1.75rem;
      margin-bottom: 1.375rem;
  }
</style>

<i18n lang="yml" locale="ru">
  h1: Партнерская программа
  text: |
    Получайте от 20 до 40% за приглашенных пользователей. <br />
    Просто поделитесь этой ссылкой, и получайте от 20 до 40% от всех покупок приглашенных пользователей
  rules: |
    Размер вознаграждения зависит от общего количества покупок приглашенных пользователей
    и каждые 25000р увеличивается на 2%
</i18n>
<i18n lang="yml" locale="en">
  h1: Partnership
  text: |
    Get 20 to 40% for your invited users.<br />
    Simply share this link and receive 20 to 40% of all purchases by invited users
  rules: |
    The amount of reward depends on the total amount of purchases of the invited users
    and increases by 2% for every $500
</i18n>
